import z from "zod"

const booleanFlags = {
  showReadonly: z.boolean(),
  showEscalate: z.boolean(),
  showInTasks: z.boolean(),
  showComplete: z.boolean(),
  isQA: z.boolean(),
  allowReopen: z.boolean(),
  hiddenProcess: z.boolean(),
}

export const StateCreateSchema = z.object({
  action: z.literal("CREATE"),
  organisation: z.string().trim().min(1, "Organisation is required"),
  project: z.string().trim(),
  name: z
    .string()
    .trim()
    .min(1, "Name is required")
    .max(100, "Name should be 100 characters or less")
    .regex(/^[a-zA-Z0-9 ]+$/, "Only alphanumeric and space characters are allowed"),
  ...booleanFlags,
})

export const StateUpdateSchema = z.object({
  action: z.literal("UPDATE"),
  organisation: z.string().trim().min(1),
  project: z.string().trim(),
  name: z.string().trim().min(1),
  ...booleanFlags,
})

export const StateDeleteSchema = z.object({
  action: z.literal("DELETE"),
  organisation: z.string().trim().min(1),
  project: z.string().trim(),
  name: z.string().trim().min(1),
})

export const StateToggleActiveSchema = z.object({
  action: z.literal("TOGGLEACTIVE"),
  organisation: z.string().trim().min(1),
  project: z.string().trim(),
  name: z.string().trim().min(1),
  active: z.boolean(),
})

export const StateEditOrCreateSchema = z.discriminatedUnion("action", [StateCreateSchema, StateUpdateSchema])

export const StateSchema = z.discriminatedUnion("action", [
  StateCreateSchema,
  StateUpdateSchema,
  StateDeleteSchema,
  StateToggleActiveSchema,
])

export interface State {
  organisation: string
  project: string | null
  name: string
  showReadonly: boolean
  showEscalate: boolean
  showInTasks: boolean
  showComplete: boolean
  isQA: boolean
  allowReopen: boolean
  hiddenProcess: boolean
  active: boolean
}

export interface StateAPIResponse {
  items: State[]
  page: number
  totalCount: number
}

export const FLAG_FIELDS: Array<{ key: keyof typeof booleanFlags; label: string }> = [
  { key: "showReadonly", label: "Show Readonly" },
  { key: "showEscalate", label: "Show Escalate" },
  { key: "showInTasks", label: "Show In Tasks" },
  { key: "showComplete", label: "Show Complete" },
  { key: "isQA", label: "Is QA" },
  { key: "allowReopen", label: "Allow Reopen" },
  { key: "hiddenProcess", label: "Hidden Process" },
]
